import React, { useState } from 'react'
import { Panel, Uploader, Row, Col, Table, Icon } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isExcel, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { updateChangeAgreement } from '../../redux/actions/contract'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import { isEmpty } from 'lodash-es'
import AppContext from '../../context/AppContext'
import classNames from 'classnames'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  ExprotMigrateBorrowAdvance,
  ImportMigrateBorrowAdvance,
  SaveMigrateBorrowAdvance,
} from '../../redux/actions/migrateEfin'
import { budgetFormat } from '../../utils/formatterUtil'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'
import { downloadFile } from '../../utils/fileUtil'

export default function BorrowAdvanceMG(props) {
  const { schema } = props
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [importResult, setImportResult] = useState()

  const { handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  const defaultMaxFileSize = 50

  const handleProcess = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await ImportMigrateBorrowAdvance(request)

      if (response.model) {
        setImportResult(response.model)

        setValue(schema.attachFile.name, '')

        notification.open('success', {
          title: `แสดงข้อมูลสำเร็จ`,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSave = async () => {
    startLoading()
    setIsLoading(true)
    setShowConfirm(false)
    try {
      let response = await SaveMigrateBorrowAdvance(importResult)

      if (response?.model?.successed) {
        notification.open('success', {
          title: `ดำเนินการสำเร็จ`,
          duration: 5000,
        })
        setImportResult([])
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log(e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleExportExcel = async (data) => {
    startLoading()
    setIsLoading(true)
    try {
      // setSearchResult(mockData)
      let file = await ExprotMigrateBorrowAdvance(data)

      if (file) {
        downloadFile(file, `Template_ข้อมูลเงินยืมทดรองจ่าย.xlsx`)
      } else {
        notification.open('error', {
          title: file?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log(e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    //console.log('data', data)

    var formData = new FormData()

    data[schema?.attachFile?.name]?.forEach((element) => {
      formData.append('file', element.blobFile)
    })

    handleProcess(formData)
  }

  return (
    <div>
      <Panel
        header={schema.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 20 }}
      >
        {isLoading && <OverlayLoader />}
        <DownloadButton
          children={`ดาวน์โหลดแบบฟอร์ม เงินยืมทดรองจ่าย`}
          onClick={() => {
            handleExportExcel({
              datas: [
                {
                  id: 'B12345',
                  projectCode: '67-XXXXX',
                  periodNo: 1,
                  documentNo: 'DOC-000001',
                  documentDate: '2024-01-15',
                  borrowAmount: 50000.0,
                  borrowDate: '2024-01-15',
                  retrunDueDate: '2024-01-15',
                  borrowerName: 'สมชาย ใจดี',
                  borrowerIdCard: '1234567890123',
                  borrowerTypeCode: '1',
                  borrowerTypeName: 'บุคคล',
                  activity: 'MT-0001',
                  activityStartDate: '2024-01-15',
                  activityEndDate: '2024-01-15',
                  payTypeCode: '2',
                  payTypeName: 'เงินโอน',
                  bankCode: '002',
                  bankName: 'ธนาคารกรุงเทพ จำกัด (มหาชน)',
                  bankBranch: 'สาขาบางนา',
                  accountTypeCode: '1',
                  accountTypeName: 'ออมทรัพย์',
                  accountNo: '1234567890',
                  accountName: 'ชุมชนน่าอยู่บ้านเด่นสำโรง',
                  borrowRemark:
                    'ใช้สำหรับกิจกรรมอบรม {รายการนี้เป็นตัวอย่างเท่านั้นให้ลบออกไปก่อนจะนำเข้าข้อมูล}',
                },
              ],
            })
          }}
        />
        {schema.attachFile && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col>{requiredFiled(schema.attachFile.validators, schema.attachFile.label)}</Col>
              <Col>
                <ErrorMessage error={errors[schema.attachFile.name]} />
                <Controller
                  key={schema.attachFile.name}
                  name={schema.attachFile.name}
                  control={control}
                  rules={isValidators(schema.attachFile.validators)}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <Uploader
                        accept={schema.attachFile.fileType || '.xlsx'}
                        autoUpload={false}
                        disabled={schema.attachFile.disabled}
                        fileListVisible={true}
                        // listType="picture-text"
                        fileList={props.value || []}
                        multiple={false}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]

                            if (
                              file.blobFile.size >
                              (schema?.attachFile?.fileSize || defaultMaxFileSize) * 1024 * 1024
                            ) {
                              notification.open('error', {
                                title: `ขนาดไฟล์เกิน ${
                                  schema.attachFile.fileSize || defaultMaxFileSize
                                } MB`,
                                duration: 5000,
                              })
                              return
                            }

                            if (isExcel(file.blobFile.type)) {
                              props.onChange([file])
                            } else {
                              notification.open('error', {
                                title: 'ชนิดที่รองรับ .xlsx',
                                duration: 5000,
                              })
                            }
                          }
                        }}
                        draggable
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                {` ชนิดที่รองรับ : ${
                                  schema.attachFile.fileType || '.xlsx'
                                } , ขนาดไฟล์ไม่เกิน ${
                                  schema.attachFile.fileSize || defaultMaxFileSize
                                } MB`}
                              </p>
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col style={{ textAlign: 'right' }}>
                <ViewButton children="แสดง" onClick={handleSubmit(onSubmit)} />
              </Col>
            </Row>
          </>
        )}

        <Table
          style={{ marginTop: 20 }}
          wordWrap
          autoHeight={importResult?.datas?.length < 6}
          height={(importResult?.datas || []).length == 0 ? 200 : 400}
          data={importResult?.datas || []}
          loading={isLoading}
        >
          <Column align="center" width={100} fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={130} fixed>
            <HeaderCell>รหัสโครงการ</HeaderCell>
            <Cell dataKey="projectCode" />
          </Column>

          <Column align="center" width={120}>
            <HeaderCell>งวดที่ยืมเงิน</HeaderCell>
            <Cell dataKey="periodNo" />
          </Column>

          <Column width={160}>
            <HeaderCell>เลขที่เอกสารอ้างอิง</HeaderCell>
            <Cell dataKey="documentNo" />
          </Column>

          <Column width={150}>
            <HeaderCell>วันที่ในเอกสาร</HeaderCell>
            <Cell dataKey="documentDate" />
          </Column>

          <Column align="right" width={120}>
            <HeaderCell>ยอดเงินยืม</HeaderCell>
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.borrowAmount)
              }}
            </Cell>
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่ยืม</HeaderCell>
            <Cell dataKey="borrowDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่กำหนดคืน</HeaderCell>
            <Cell dataKey="retrunDueDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>ชื่อผู้ยืมเงินทดรองจ่าย</HeaderCell>
            <Cell dataKey="borrowerName" />
          </Column>
          <Column width={160}>
            <HeaderCell>เลขที่บัตรประชาชน</HeaderCell>
            <Cell dataKey="borrowerIdCard" />
          </Column>
          {/* <Column width={150}>
            <HeaderCell>ประเภทผู้ยืมเงิน</HeaderCell>
            <Cell dataKey="borrowerTypeName" />
          </Column> */}
          <Column width={150}>
            <HeaderCell>ยืมทำกิจกรรม</HeaderCell>
            <Cell dataKey="activity" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่เริ่มต้นกิจกรรม</HeaderCell>
            <Cell dataKey="activityStartDate" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่สิ้นสุดกิจกรรม</HeaderCell>
            <Cell dataKey="activityEndDate" />
          </Column>
          <Column width={120}>
            <HeaderCell>จ่ายโดย</HeaderCell>
            <Cell dataKey="payTypeName" />
          </Column>
          <Column width={250}>
            <HeaderCell>ธนาคาร</HeaderCell>
            <Cell dataKey="bankName" />
          </Column>
          <Column width={150}>
            <HeaderCell>สาขา</HeaderCell>
            <Cell dataKey="bankBranch" />
          </Column>
          <Column width={120}>
            <HeaderCell>ประเภทบัญชี</HeaderCell>
            <Cell dataKey="accountTypeName" />
          </Column>
          <Column width={200}>
            <HeaderCell>เลขที่บัญชี</HeaderCell>
            <Cell dataKey="accountNo" />
          </Column>
          <Column width={350}>
            <HeaderCell>ชื่อบัญชี</HeaderCell>
            <Cell dataKey="accountName" />
          </Column>
          <Column width={350}>
            <HeaderCell>คำอธิบาย วัตถุประสงค์การยืม</HeaderCell>
            <Cell dataKey="borrowRemark" />
          </Column>
        </Table>

        {importResult?.datas?.length > 0 && (
          <>
            <Row style={{ marginTop: 20 }}>
              <Col style={{ textAlign: 'right' }}>
                <SaveButton
                  children="ดำเนินการ"
                  disabled={isLoading}
                  onClick={() => {
                    setShowConfirm(true)
                  }}
                />
              </Col>
            </Row>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยัน`}
        show={showConfirm}
        detail={`ยืนยันการ ${schema.header}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={handleSave}
      />
    </div>
  )
}
